import * as React from 'react';

const GuidedTourIntroBannerDark: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576.59399 436.20001" {...props}>
    <defs id="defs23">
      <clipPath id="b">
        <circle id="circle1" cx={509.815} cy={413.29871} r={165.4821} className="ae" />
      </clipPath>
      <clipPath id="c">
        <path
          id="path1"
          d="M589.333 328.206c67.54 3.683 121.17 59.616 121.17 128.074 0 70.84-57.427 128.268-128.268 128.268-70.839 0-128.267-57.429-128.267-128.268 0-70.84 57.428-128.268 128.267-128.268 2.383 0 4.749.065 7.098.194"
          className="ae"
        />
      </clipPath>
      <clipPath id="d">
        <path id="path2" d="M449.712 433.149h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="e">
        <path id="path3" d="M449.712 427.865h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="f">
        <path id="path4" d="M449.712 422.58h5.284v5.285h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="g">
        <path id="path5" d="M449.712 417.297h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="h">
        <path id="path6" d="M449.712 412.013h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="i">
        <path id="path7" d="M449.712 406.728h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="j">
        <path id="path8" d="M449.712 401.444h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="k">
        <path id="path9" d="M449.712 396.16h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="l">
        <path id="path10" d="M449.712 390.875h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="m">
        <path id="path11" d="M449.712 385.59h5.284v5.285h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="n">
        <path id="path12" d="M449.712 380.307h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="o">
        <path id="path13" d="M449.712 375.023h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="p">
        <path id="path14" d="M449.712 369.738h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="q">
        <path id="path15" d="M449.712 364.454h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="r">
        <path id="path16" d="M449.712 359.17h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="s">
        <path id="path17" d="M449.712 353.885h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="t">
        <path id="path18" d="M449.712 348.6h5.284v5.285h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="u">
        <path id="path19" d="M449.712 343.317h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="v">
        <path id="path20" d="M449.712 338.033h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="w">
        <path id="path21" d="M449.712 332.748h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="x">
        <path id="path22" d="M449.712 327.464h5.284v5.284h-5.284z" className="ae" />
      </clipPath>
      <clipPath id="y">
        <circle id="circle22" cx={518.66309} cy={274.36139} r={22.1703} className="ae" />
      </clipPath>
      <clipPath id="z">
        <circle id="circle23" cx={478.64999} cy={247.8166} r={11.2009} className="ae" />
      </clipPath>
      <style id="style1">
        {
          '.aa,.ab,.ad,.ae,.af,.ah,.ai,.ak{fill:none}.aa,.ab,.ad,.af,.ah,.ai{stroke-miterlimit:10}.aa,.ab,.ad,.ah,.ai,.ak{stroke-linecap:round}.aa,.ab,.ah,.ai{stroke-width:1.5px}.aa,.ai{stroke:#000}.ab{stroke:#fff}.ad,.af,.ak{stroke:#e00}.ad,.ak{stroke-width:3px}.ae,.ao,.ap,.aq,.ar,.as,.au,.av{stroke-width:0}.ao{opacity:.75;fill:#b88564}.af{stroke-width:.8246px}.ah{stroke:#c7c7c7}.ai{stroke-dasharray:0 0 6 6}.aq{fill:#c7c7c7}.ar{fill:#e0e0e0}.as{fill:#d8a381}.au{fill:#fff}.av{fill:#e00}.ak{stroke-linejoin:round}'
        }
      </style>
    </defs>
    <g id="g290" transform="translate(-98.703 -181.9)">
      <path
        id="path23"
        d="M552.558 253.173c-37.137-9.308-72.948-6.05-104.095 6.397-12.948 5.175-27.893.648-35.433-11.083-25.621-39.862-70.264-66.334-121.112-66.585-79.609-.394-145.156 64.539-145.477 144.148-.218 53.969 29.104 101.102 72.721 126.172 7.35 4.224 11.233 12.635 9.85 20.999a98.504 98.504 0 00-1.294 18.095c1.08 52.781 44.418 95.721 97.207 96.313 27.722.31 52.832-10.854 70.89-29.033 7.513-7.563 19.188-9.239 28.302-3.71 24.996 15.163 54.327 23.895 85.698 23.895 104.673 0 186.647-97.184 160.615-206.244-13.965-58.502-59.53-104.741-117.872-119.364z"
        className="ar"
      />
      <path
        id="path24"
        d="M416.664 332.534c0-31.617-25.63-57.248-57.248-57.248a58 58 0 00-3.737.134c-10.953-36.673-44.938-63.409-85.173-63.409-35.757 0-66.578 21.117-80.685 51.558-31.435 1.505-16.805 59.252-57.743 58.434-18.48.28-33.375 15.338-33.375 33.883 0 18.53 14.872 33.578 33.33 33.882v.014H359.68v-.007c31.495-.143 56.983-25.713 56.983-57.24z"
        className="aq"
      />
      <path
        id="path25"
        d="M606.695 374.83c.905-1.86 2.852-5.633.68-7.31-.73-.563.142-1.681.879-1.129 2.842 2.13.986 6.53-.24 9.004-.407.823-1.725.27-1.319-.565z"
        className="ao"
      />
      <g id="g250" clipPath="url(#b)">
        <path
          id="path26"
          d="M399.8 611.933c1.057-7.44 2.824-15 6.817-21.472 4.284-6.941 9.16-15.78 15.953-20.116 13.387-8.543 29.604-11.546 44.635-16.623 17.183-5.804 35.17-9.111 53.265-10.18 4.497-.265 8.332 4.02 8.332 8.333 0 .31-.018.612-.05.91 3.388-.454 6.799-.776 10.235-.934 2.559-.117 4.899 1.189 6.443 3.136a8.438 8.438 0 012.724 1.729c3.353-4.941 11.595-4.711 14.935.347 1.112-.536 2.312-.848 3.486-.848 4.843 0 7.812 3.805 8.264 8.264 1.657 16.342-8.35 31.36-23.11 37.767-7.853 3.408-16.236 4.988-24.627 6.463-8.862 1.558-17.778 2.777-26.694 3.974-8.58 1.151-17.164 2.266-25.714 3.626-8.374 1.333-17.46 2.346-25.495 5.146-2.668.93-3.343 2.76-4.455 5.346-1.674 3.896-3.095 7.921-4.41 11.95-2.61 8-18.39 61.704-19.855 80.447-.458 5.852-4.927 8.89-10.542 8.03-5.918-.905-11.911-1.22-17.894-1.2-4.366.014-8.513-3.829-8.328-8.329 1.453-35.304 11.112-70.767 16.084-105.766z"
          className="aq"
        />
        <path
          id="path27"
          d="M616.122 436.364l38.003 8.085a21.39 21.39 0 0116.939 20.922v98.673c0 13.255-11.933 23.319-24.998 21.083l-42.834-7.33z"
          className="ap"
        />
        <path
          id="path28"
          d="M417.398 750.625s-83.883 1.73-87.005 7.584c-3.122 5.854-5.088 14.702 25.39 12.736 30.48-1.966 39.329 8.193 67.514 6.555 28.185-1.64 83.573-4.916 83.573-4.916l-33.43-19.992z"
          className="ar"
        />
        <ellipse
          id="ellipse28"
          cx={565.5426}
          cy={746.6496}
          className="ar"
          rx={159.8987}
          ry={32.217201}
        />
        <path
          id="path29"
          d="M369.657 738.632c1.882-6.925 3.845-14.248 6.928-20.753.836-1.765 2.198-3.037 4.283-2.682 1.34.228 2.62 1.067 3.908 1.495 2.022.672 4.085.898 6.205.915.207.002.41.03.604.082.283-.286.63-.494 1.03-.552l.192-.027c1.77-.256 2.953.662 3.183 2.424.404 3.107-1.672 7.793-2.414 10.823-.817 3.335-1.08 7.922-2.817 10.905-1.423 2.444-4.581 2-7.01 1.922-4.145-.136-8.254-.662-12.325-1.44-1.347-.257-2.103-1.876-1.767-3.112z"
          className="as"
        />
        <path
          id="path30"
          d="M393.605 730.25c.763-3.032 2.785-7.643 2.384-10.716-.23-1.762-1.413-2.68-3.182-2.424l-.193.027c-.4.058-.746.266-1.029.552a2.437 2.437 0 00-.604-.082c-2.12-.017-4.183-.243-6.205-.915-1.288-.428-2.567-1.267-3.908-1.495-2.085-.355-3.447.917-4.283 2.682-1.532 3.233-2.787 6.668-3.893 10.155 3.58 1.098 10.294 2.466 20.913 2.215z"
          className="ao"
        />
        <g id="g220" clipPath="url(#c)">
          <g id="g39" clipPath="url(#d)">
            <path id="path31" d="M460.285 433.154l-5.294-5.294" className="af" />
            <path id="path32" d="M455.001 433.154l-5.295-5.294" className="af" />
            <path id="path33" d="M449.717 433.154l-5.295-5.294" className="af" />
            <path id="path34" d="M460.285 438.438l-5.294-5.293" className="af" />
            <path id="path35" d="M455.001 438.438l-5.295-5.293" className="af" />
            <path id="path36" d="M449.717 438.438l-5.295-5.293" className="af" />
            <path id="path37" d="M460.285 443.722l-5.294-5.293" className="af" />
            <path id="path38" d="M455.001 443.722l-5.295-5.293" className="af" />
            <path id="path39" d="M449.717 443.722l-5.295-5.293" className="af" />
          </g>
          <g id="g48" clipPath="url(#e)">
            <path id="path40" d="M460.285 427.87l-5.294-5.294" className="af" />
            <path id="path41" d="M455.001 427.87l-5.295-5.294" className="af" />
            <path id="path42" d="M449.717 427.87l-5.295-5.294" className="af" />
            <path id="path43" d="M460.285 433.154l-5.294-5.294" className="af" />
            <path id="path44" d="M455.001 433.154l-5.295-5.294" className="af" />
            <path id="path45" d="M449.717 433.154l-5.295-5.294" className="af" />
            <path id="path46" d="M460.285 438.438l-5.294-5.293" className="af" />
            <path id="path47" d="M455.001 438.438l-5.295-5.293" className="af" />
            <path id="path48" d="M449.717 438.438l-5.295-5.293" className="af" />
          </g>
          <g id="g57" clipPath="url(#f)">
            <path id="path49" d="M460.285 422.585l-5.294-5.293" className="af" />
            <path id="path50" d="M455.001 422.585l-5.295-5.293" className="af" />
            <path id="path51" d="M449.717 422.585l-5.295-5.293" className="af" />
            <path id="path52" d="M460.285 427.87l-5.294-5.294" className="af" />
            <path id="path53" d="M455.001 427.87l-5.295-5.294" className="af" />
            <path id="path54" d="M449.717 427.87l-5.295-5.294" className="af" />
            <path id="path55" d="M460.285 433.154l-5.294-5.294" className="af" />
            <path id="path56" d="M455.001 433.154l-5.295-5.294" className="af" />
            <path id="path57" d="M449.717 433.154l-5.295-5.294" className="af" />
          </g>
          <g id="g66" clipPath="url(#g)">
            <path id="path58" d="M460.285 417.301l-5.294-5.294" className="af" />
            <path id="path59" d="M455.001 417.301l-5.295-5.294" className="af" />
            <path id="path60" d="M449.717 417.301l-5.295-5.294" className="af" />
            <path id="path61" d="M460.285 422.585l-5.294-5.293" className="af" />
            <path id="path62" d="M455.001 422.585l-5.295-5.293" className="af" />
            <path id="path63" d="M449.717 422.585l-5.295-5.293" className="af" />
            <path id="path64" d="M460.285 427.87l-5.294-5.294" className="af" />
            <path id="path65" d="M455.001 427.87l-5.295-5.294" className="af" />
            <path id="path66" d="M449.717 427.87l-5.295-5.294" className="af" />
          </g>
          <g id="g75" clipPath="url(#h)">
            <path id="path67" d="M460.285 412.017l-5.294-5.294" className="af" />
            <path id="path68" d="M455.001 412.017l-5.295-5.294" className="af" />
            <path id="path69" d="M449.717 412.017l-5.295-5.294" className="af" />
            <path id="path70" d="M460.285 417.301l-5.294-5.294" className="af" />
            <path id="path71" d="M455.001 417.301l-5.295-5.294" className="af" />
            <path id="path72" d="M449.717 417.301l-5.295-5.294" className="af" />
            <path id="path73" d="M460.285 422.585l-5.294-5.293" className="af" />
            <path id="path74" d="M455.001 422.585l-5.295-5.293" className="af" />
            <path id="path75" d="M449.717 422.585l-5.295-5.293" className="af" />
          </g>
          <g id="g84" clipPath="url(#i)">
            <path id="path76" d="M460.285 406.732l-5.294-5.293" className="af" />
            <path id="path77" d="M455.001 406.732l-5.295-5.293" className="af" />
            <path id="path78" d="M449.717 406.732l-5.295-5.293" className="af" />
            <path id="path79" d="M460.285 412.017l-5.294-5.294" className="af" />
            <path id="path80" d="M455.001 412.017l-5.295-5.294" className="af" />
            <path id="path81" d="M449.717 412.017l-5.295-5.294" className="af" />
            <path id="path82" d="M460.285 417.301l-5.294-5.294" className="af" />
            <path id="path83" d="M455.001 417.301l-5.295-5.294" className="af" />
            <path id="path84" d="M449.717 417.301l-5.295-5.294" className="af" />
          </g>
          <g id="g93" clipPath="url(#j)">
            <path id="path85" d="M460.285 401.448l-5.294-5.294" className="af" />
            <path id="path86" d="M455.001 401.448l-5.295-5.294" className="af" />
            <path id="path87" d="M449.717 401.448l-5.295-5.294" className="af" />
            <path id="path88" d="M460.285 406.732l-5.294-5.293" className="af" />
            <path id="path89" d="M455.001 406.732l-5.295-5.293" className="af" />
            <path id="path90" d="M449.717 406.732l-5.295-5.293" className="af" />
            <path id="path91" d="M460.285 412.017l-5.294-5.294" className="af" />
            <path id="path92" d="M455.001 412.017l-5.295-5.294" className="af" />
            <path id="path93" d="M449.717 412.017l-5.295-5.294" className="af" />
          </g>
          <g id="g102" clipPath="url(#k)">
            <path id="path94" d="M460.285 396.164l-5.294-5.294" className="af" />
            <path id="path95" d="M455.001 396.164l-5.295-5.294" className="af" />
            <path id="path96" d="M449.717 396.164l-5.295-5.294" className="af" />
            <path id="path97" d="M460.285 401.448l-5.294-5.294" className="af" />
            <path id="path98" d="M455.001 401.448l-5.295-5.294" className="af" />
            <path id="path99" d="M449.717 401.448l-5.295-5.294" className="af" />
            <path id="path100" d="M460.285 406.732l-5.294-5.293" className="af" />
            <path id="path101" d="M455.001 406.732l-5.295-5.293" className="af" />
            <path id="path102" d="M449.717 406.732l-5.295-5.293" className="af" />
          </g>
          <g id="g111" clipPath="url(#l)">
            <path id="path103" d="M460.285 390.88l-5.294-5.294" className="af" />
            <path id="path104" d="M455.001 390.88l-5.295-5.294" className="af" />
            <path id="path105" d="M449.717 390.88l-5.295-5.294" className="af" />
            <path id="path106" d="M460.285 396.164l-5.294-5.294" className="af" />
            <path id="path107" d="M455.001 396.164l-5.295-5.294" className="af" />
            <path id="path108" d="M449.717 396.164l-5.295-5.294" className="af" />
            <path id="path109" d="M460.285 401.448l-5.294-5.294" className="af" />
            <path id="path110" d="M455.001 401.448l-5.295-5.294" className="af" />
            <path id="path111" d="M449.717 401.448l-5.295-5.294" className="af" />
          </g>
          <g id="g120" clipPath="url(#m)">
            <path id="path112" d="M460.285 385.595l-5.294-5.293" className="af" />
            <path id="path113" d="M455.001 385.595l-5.295-5.293" className="af" />
            <path id="path114" d="M449.717 385.595l-5.295-5.293" className="af" />
            <path id="path115" d="M460.285 390.88l-5.294-5.294" className="af" />
            <path id="path116" d="M455.001 390.88l-5.295-5.294" className="af" />
            <path id="path117" d="M449.717 390.88l-5.295-5.294" className="af" />
            <path id="path118" d="M460.285 396.164l-5.294-5.294" className="af" />
            <path id="path119" d="M455.001 396.164l-5.295-5.294" className="af" />
            <path id="path120" d="M449.717 396.164l-5.295-5.294" className="af" />
          </g>
          <g id="g129" clipPath="url(#n)">
            <path id="path121" d="M460.285 380.311l-5.294-5.294" className="af" />
            <path id="path122" d="M455.001 380.311l-5.295-5.294" className="af" />
            <path id="path123" d="M449.717 380.311l-5.295-5.294" className="af" />
            <path id="path124" d="M460.285 385.595l-5.294-5.293" className="af" />
            <path id="path125" d="M455.001 385.595l-5.295-5.293" className="af" />
            <path id="path126" d="M449.717 385.595l-5.295-5.293" className="af" />
            <path id="path127" d="M460.285 390.88l-5.294-5.294" className="af" />
            <path id="path128" d="M455.001 390.88l-5.295-5.294" className="af" />
            <path id="path129" d="M449.717 390.88l-5.295-5.294" className="af" />
          </g>
          <g id="g138" clipPath="url(#o)">
            <path id="path130" d="M460.285 375.027l-5.294-5.294" className="af" />
            <path id="path131" d="M455.001 375.027l-5.295-5.294" className="af" />
            <path id="path132" d="M449.717 375.027l-5.295-5.294" className="af" />
            <path id="path133" d="M460.285 380.311l-5.294-5.294" className="af" />
            <path id="path134" d="M455.001 380.311l-5.295-5.294" className="af" />
            <path id="path135" d="M449.717 380.311l-5.295-5.294" className="af" />
            <path id="path136" d="M460.285 385.595l-5.294-5.293" className="af" />
            <path id="path137" d="M455.001 385.595l-5.295-5.293" className="af" />
            <path id="path138" d="M449.717 385.595l-5.295-5.293" className="af" />
          </g>
          <g id="g147" clipPath="url(#p)">
            <path id="path139" d="M460.285 369.743l-5.294-5.294" className="af" />
            <path id="path140" d="M455.001 369.743l-5.295-5.294" className="af" />
            <path id="path141" d="M449.717 369.743l-5.295-5.294" className="af" />
            <path id="path142" d="M460.285 375.027l-5.294-5.294" className="af" />
            <path id="path143" d="M455.001 375.027l-5.295-5.294" className="af" />
            <path id="path144" d="M449.717 375.027l-5.295-5.294" className="af" />
            <path id="path145" d="M460.285 380.311l-5.294-5.294" className="af" />
            <path id="path146" d="M455.001 380.311l-5.295-5.294" className="af" />
            <path id="path147" d="M449.717 380.311l-5.295-5.294" className="af" />
          </g>
          <g id="g156" clipPath="url(#q)">
            <path id="path148" d="M460.285 364.458l-5.294-5.294" className="af" />
            <path id="path149" d="M455.001 364.458l-5.295-5.294" className="af" />
            <path id="path150" d="M449.717 364.458l-5.295-5.294" className="af" />
            <path id="path151" d="M460.285 369.743l-5.294-5.294" className="af" />
            <path id="path152" d="M455.001 369.743l-5.295-5.294" className="af" />
            <path id="path153" d="M449.717 369.743l-5.295-5.294" className="af" />
            <path id="path154" d="M460.285 375.027l-5.294-5.294" className="af" />
            <path id="path155" d="M455.001 375.027l-5.295-5.294" className="af" />
            <path id="path156" d="M449.717 375.027l-5.295-5.294" className="af" />
          </g>
          <g id="g165" clipPath="url(#r)">
            <path id="path157" d="M460.285 359.174l-5.294-5.294" className="af" />
            <path id="path158" d="M455.001 359.174l-5.295-5.294" className="af" />
            <path id="path159" d="M449.717 359.174l-5.295-5.294" className="af" />
            <path id="path160" d="M460.285 364.458l-5.294-5.294" className="af" />
            <path id="path161" d="M455.001 364.458l-5.295-5.294" className="af" />
            <path id="path162" d="M449.717 364.458l-5.295-5.294" className="af" />
            <path id="path163" d="M460.285 369.743l-5.294-5.294" className="af" />
            <path id="path164" d="M455.001 369.743l-5.295-5.294" className="af" />
            <path id="path165" d="M449.717 369.743l-5.295-5.294" className="af" />
          </g>
          <g id="g174" clipPath="url(#s)">
            <path id="path166" d="M460.285 353.89l-5.294-5.294" className="af" />
            <path id="path167" d="M455.001 353.89l-5.295-5.294" className="af" />
            <path id="path168" d="M449.717 353.89l-5.295-5.294" className="af" />
            <path id="path169" d="M460.285 359.174l-5.294-5.294" className="af" />
            <path id="path170" d="M455.001 359.174l-5.295-5.294" className="af" />
            <path id="path171" d="M449.717 359.174l-5.295-5.294" className="af" />
            <path id="path172" d="M460.285 364.458l-5.294-5.294" className="af" />
            <path id="path173" d="M455.001 364.458l-5.295-5.294" className="af" />
            <path id="path174" d="M449.717 364.458l-5.295-5.294" className="af" />
          </g>
          <g id="g183" clipPath="url(#t)">
            <path id="path175" d="M460.285 348.605l-5.294-5.293" className="af" />
            <path id="path176" d="M455.001 348.605l-5.295-5.293" className="af" />
            <path id="path177" d="M449.717 348.605l-5.295-5.293" className="af" />
            <path id="path178" d="M460.285 353.89l-5.294-5.294" className="af" />
            <path id="path179" d="M455.001 353.89l-5.295-5.294" className="af" />
            <path id="path180" d="M449.717 353.89l-5.295-5.294" className="af" />
            <path id="path181" d="M460.285 359.174l-5.294-5.294" className="af" />
            <path id="path182" d="M455.001 359.174l-5.295-5.294" className="af" />
            <path id="path183" d="M449.717 359.174l-5.295-5.294" className="af" />
          </g>
          <g id="g192" clipPath="url(#u)">
            <path id="path184" d="M460.285 343.321l-5.294-5.294" className="af" />
            <path id="path185" d="M455.001 343.321l-5.295-5.294" className="af" />
            <path id="path186" d="M449.717 343.321l-5.295-5.294" className="af" />
            <path id="path187" d="M460.285 348.605l-5.294-5.293" className="af" />
            <path id="path188" d="M455.001 348.605l-5.295-5.293" className="af" />
            <path id="path189" d="M449.717 348.605l-5.295-5.293" className="af" />
            <path id="path190" d="M460.285 353.89l-5.294-5.294" className="af" />
            <path id="path191" d="M455.001 353.89l-5.295-5.294" className="af" />
            <path id="path192" d="M449.717 353.89l-5.295-5.294" className="af" />
          </g>
          <g id="g201" clipPath="url(#v)">
            <path id="path193" d="M460.285 338.037l-5.294-5.294" className="af" />
            <path id="path194" d="M455.001 338.037l-5.295-5.294" className="af" />
            <path id="path195" d="M449.717 338.037l-5.295-5.294" className="af" />
            <path id="path196" d="M460.285 343.321l-5.294-5.294" className="af" />
            <path id="path197" d="M455.001 343.321l-5.295-5.294" className="af" />
            <path id="path198" d="M449.717 343.321l-5.295-5.294" className="af" />
            <path id="path199" d="M460.285 348.605l-5.294-5.293" className="af" />
            <path id="path200" d="M455.001 348.605l-5.295-5.293" className="af" />
            <path id="path201" d="M449.717 348.605l-5.295-5.293" className="af" />
          </g>
          <g id="g210" clipPath="url(#w)">
            <path id="path202" d="M460.285 332.752l-5.294-5.293" className="af" />
            <path id="path203" d="M455.001 332.752l-5.295-5.293" className="af" />
            <path id="path204" d="M449.717 332.752l-5.295-5.293" className="af" />
            <path id="path205" d="M460.285 338.037l-5.294-5.294" className="af" />
            <path id="path206" d="M455.001 338.037l-5.295-5.294" className="af" />
            <path id="path207" d="M449.717 338.037l-5.295-5.294" className="af" />
            <path id="path208" d="M460.285 343.321l-5.294-5.294" className="af" />
            <path id="path209" d="M455.001 343.321l-5.295-5.294" className="af" />
            <path id="path210" d="M449.717 343.321l-5.295-5.294" className="af" />
          </g>
          <g id="g219" clipPath="url(#x)">
            <path id="path211" d="M460.285 327.468l-5.294-5.294" className="af" />
            <path id="path212" d="M455.001 327.468l-5.295-5.294" className="af" />
            <path id="path213" d="M449.717 327.468l-5.295-5.294" className="af" />
            <path id="path214" d="M460.285 332.752l-5.294-5.293" className="af" />
            <path id="path215" d="M455.001 332.752l-5.295-5.293" className="af" />
            <path id="path216" d="M449.717 332.752l-5.295-5.293" className="af" />
            <path id="path217" d="M460.285 338.037l-5.294-5.294" className="af" />
            <path id="path218" d="M455.001 338.037l-5.295-5.294" className="af" />
            <path id="path219" d="M449.717 338.037l-5.295-5.294" className="af" />
          </g>
        </g>
        <path
          id="path220"
          d="M465.995 616.605c-9.774 43.409-19.004 86.959-27.906 130.556-.817.629-1.435 1.628-1.681 2.747-.528 2.402.432 5.02 3.054 5.56 2.517.516 5.028-1.494 5.455-3.948.206-1.187-.154-2.47-.983-3.345-.039-.041-.083-.074-.124-.112 9.04-43.486 18.373-86.9 27.793-130.305.782-3.604-4.799-4.749-5.608-1.153zM582.9 760.874c-.047-.03-.099-.05-.147-.078-1.985-44.37-3.67-88.746-5.266-133.132-.132-3.686-5.823-3.416-5.72.269 1.256 44.478 3.073 88.958 5.219 133.402-.636.812-.988 1.933-.95 3.078.082 2.458 1.659 4.758 4.333 4.632 2.567-.12 4.502-2.69 4.31-5.173-.093-1.201-.759-2.354-1.779-2.998zm93.213-27.375c-.39-1.14-1.323-2.09-2.471-2.46-.054-.017-.109-.024-.163-.038-13.002-42.47-25.715-85.018-38.344-127.6-1.049-3.535-6.492-1.852-5.471 1.69 12.322 42.755 25.19 85.372 38.366 127.872-.413.945-.474 2.119-.151 3.218.693 2.36 2.794 4.193 5.352 3.403 2.455-.758 3.688-3.728 2.882-6.085z"
          className="av"
        />
        <path
          id="path221"
          d="M435.032 742.995c1.882-6.926 3.845-14.248 6.928-20.754.836-1.765 2.199-3.036 4.283-2.682 1.34.229 2.62 1.067 3.908 1.495 2.022.673 4.085.898 6.205.915.207.002.41.03.604.082.283-.286.63-.494 1.03-.551l.192-.028c1.77-.256 2.953.662 3.183 2.424.404 3.108-1.672 7.794-2.414 10.823-.817 3.335-1.08 7.922-2.817 10.905-1.423 2.444-4.58 2.001-7.01 1.922-4.145-.135-8.254-.662-12.325-1.44-1.346-.257-2.103-1.876-1.767-3.111z"
          className="as"
        />
        <path
          id="path222"
          d="M458.225 738.469c.23-1.32.446-2.61.725-3.75.742-3.03 2.82-7.716 2.415-10.823-.23-1.762-1.414-2.68-3.183-2.424l-.193.028c-.4.057-.746.265-1.029.551a2.444 2.444 0 00-.604-.082c-2.12-.017-4.183-.242-6.205-.915-1.289-.428-2.568-1.266-3.908-1.495-2.085-.354-3.447.917-4.284 2.682-1.986 4.192-3.504 8.722-4.839 13.268 2.5 1.002 9.096 3.034 21.104 2.96z"
          className="ao"
        />
        <path
          id="path223"
          d="M442.298 621c1.057-7.44 2.825-15 6.818-21.472 4.284-6.941 10.705-12.052 17.499-16.388 13.386-8.543 28.058-15.275 43.089-20.351 17.183-5.804 35.17-9.112 53.265-10.18 4.497-.265 14.348 3.64 14.316 3.938 3.387-.454.764 4.528 4.2 4.37 2.56-.117 4.9 1.189 6.443 3.137a8.437 8.437 0 012.725 1.728c3.353-4.94 11.594-4.71 14.934.347 1.113-.535 2.312-.847 3.487-.847 4.843 0 7.811 3.804 8.263 8.263 1.657 16.342-8.349 31.361-23.109 37.767-7.853 3.409-16.236 4.989-24.628 6.464-8.862 1.558-17.778 2.776-26.694 3.973-8.579 1.152-17.164 2.266-25.713 3.627-8.375 1.333-17.46 2.345-25.495 5.145-2.669.93-3.344 2.762-4.455 5.347-1.674 3.896-3.095 7.92-4.41 11.95-2.61 8-4.642 16.18-6.258 24.435-3.616 18.476-5.074 37.268-6.54 56.012-.457 5.852-4.926 8.89-10.541 8.03-5.918-.906-11.911-1.22-17.894-1.2-4.366.013-8.513-3.829-8.328-8.329 1.453-35.305 4.053-70.768 9.026-105.766z"
          className="aq"
        />
        <path
          id="path224"
          d="M483.485 525.937a7.12 7.12 0 012.648-.223c1.686-1.019 3.423 9.23 4.991 8.311 2.803-1.64 6.289-4.861 9.735-8.56 3.261-3.499 7.088-11.173 8.956-15.639 4.175-9.978 5.27-24.308 7.57-34.786 2.707-12.325 7.295-30.006 13.341-41.147 6.238-11.494 10.509-13.77 23.434-16.209 13.786-2.6 11.096-6.47 18.467-6.632 2.513-1.166 29.058-7.132 31.583-4.629 15.55 15.415 22.967 10.452 34.292 17.758 10.375 6.693 15.688 19.642 15.73 31.961.094 27.77-1.511 43.023-12.253 67.31-1.017 2.299-.928 8.606-3.422 8.765-7.01 15.452-28.336 22.336-43.893 25.745-22.575 4.948-42.619 7.819-42.812.162-.144-5.672-9.271-5.692-20.866-5.528-16.356.231-37.623 2.171-45.504.792-6.065-1.06-6.514-8.34-3.584-12.383-2.02-.89-3.91-2.785-4.288-4.94-.809-4.61 1.219-8.796 5.875-10.128z"
          className="au"
        />
        <path
          id="path225"
          d="M576.69 370.203c5.407.128 10.815.254 16.222.383 2.297.054 4.6-.11 6.363 1.71.617.636 1.008 1.363 1.264 2.145 1.373.24 2.55 1.286 2.662 3.268.645 11.383 1.274 17.74 1.903 29.124.236 4.266-2.852 6.087-7.296 8.26-3.721 1.82-5.417 4.586-9.36 4.588-3.594.003-10.369 1.296-12.908-1.967-1.244-1.598-1.207-3.885-1.378-5.878-.233-2.713-.44-.404-.626-3.122-.771-11.33-2.626-35.185-2.6-46.567.007-2.799 3.21 7.996 5.754 8.056zm-24.928 173.826L563 538.7s5.583 3.569 5.33 14.656c0 0-.13 3.978-7.24 3.978s-11.965-3.3-11.965-3.3l2.637-10.006z"
          className="as"
        />
        <path
          id="path226"
          d="M540.925 457.848c-5.83 15.186-7.438 31.237-9.101 47.291-.767 7.409-2.06 14.6-4.738 21.582-2.778 7.24-6.526 14.05-10.33 20.79m33.116-3.031s1.894-7.98 10.21-6.897c8.318 1.082 10.025 16.845 6.636 22.048"
          className="ah"
        />
        <path
          id="path227"
          d="M507.717 548.497c2.341-3.033 4.73-6.595 7.529-8.862 1.485-1.203 3.104-2.563 4.921-3.218 1.946-.703 3.445.385 5.2.609 1.1-.985 2.467-1.573 4.458-1.375 2.231.221 4.057 1.431 5.95 2.531a45.714 45.714 0 008.416 3.799c2.491.838 5.027 1.411 7.571 2.047 1.796.45 3.756 1.145 4.358 3.11 1.235 4.03-3.716 6.741-6.995 6.896-4.968.233-10.432-2.272-14.459-4.994-1.66-1.122-4.94-3.318-6.55-5.77-1.145 1.907-3.217 3.429-4.614 5.313-1.05 1.415-3.559 3.257-5.508 3.378-1.367.085-3.612-.018-3.697-1.414-.025-.403.157-.871.474-1.374-.18.128-.35.267-.53.393-1.74 1.21-5.3 4.53-7.692 3.606-2.357-.912-.455-2.572 1.168-4.675z"
          className="as"
        />
        <path
          id="path228"
          d="M460.197 756.528c.15-6.8.57-20.738-11.323-16.05-1.163.46-2.366 1.486-3.587 1.708-1.572.286-6.558-4.95-9.706-4.375-4.723.862-4.804 2.82-6.404 6.886-1.913 4.861-7.283 8.732-11.98 11.213-5.579 2.95-11.913 4.92-17.844 7.03-1.119.398-1.95 1.333-1.954 2.565-.002.652-1.372 6.491 3.2 7.672 4.037 1.043 22.697 2.632 27.285 1.34 2.012-.568 3.915-1.425 5.953-1.92 1.624-.393 4.133-1.802 6.073-1.158.493.163 2.355 1.075 2.997 1.123 5.91.442 10.943.424 15.52-.883 1.547-.442 1.688-11.39 1.77-15.151zm-67.006-7.297c.15-6.8.57-20.738-11.323-16.049-1.164.459-2.367 1.486-3.588 1.708-1.572.285-6.558-4.95-9.706-4.376-4.722.862-4.804 2.821-6.404 6.886-1.913 4.861-7.283 8.732-11.979 11.214-5.58 2.949-11.914 4.92-17.845 7.03-1.118.397-1.949 1.332-1.953 2.565-.002.651-1.372 6.49 3.199 7.671 4.037 1.043 22.697 2.633 27.285 1.34 2.013-.567 3.915-1.425 5.953-1.919 1.624-.394 4.134-1.803 6.074-1.159.493.163 2.354 1.076 2.996 1.124 5.91.441 10.944.423 15.52-.884 1.547-.442 1.689-11.39 1.771-15.15z"
          className="aq"
        />
        <path
          id="path229"
          d="M429.125 745.005c4.193.649 8.028 2.153 11.953 3.94.84.383.11 1.606-.722 1.236-3.958-1.757-7.687-3.26-11.901-3.837.25-.438.472-.885.67-1.34zm-7.042 8.117a49.12 49.12 0 019.477 3.616c.825.417.1 1.65-.725 1.24a49.326 49.326 0 00-10.299-3.761c.522-.352 1.04-.715 1.547-1.095zm4.407-4.035a49.09 49.09 0 019.894 3.73c.826.416.1 1.649-.724 1.238a49.333 49.333 0 00-10.297-3.76c.393-.393.77-.794 1.128-1.208zm-64.97-10.815c4.192.649 8.027 2.153 11.952 3.94.84.383.11 1.606-.722 1.236-3.958-1.757-7.686-3.26-11.901-3.837.25-.438.472-.885.67-1.34zm-7.042 8.118a49.114 49.114 0 019.476 3.615c.826.416.1 1.65-.725 1.239a49.326 49.326 0 00-10.299-3.76c.522-.352 1.04-.715 1.548-1.095zm4.407-4.036a49.078 49.078 0 019.893 3.729c.826.417.1 1.65-.724 1.24a49.333 49.333 0 00-10.297-3.76c.393-.394.771-.796 1.128-1.209z"
          className="au"
        />
        <path
          id="path230"
          d="M442.353 527.924c0-3.643 2.963-6.607 6.607-6.607s6.608 2.964 6.608 6.607a6.615 6.615 0 01-6.608 6.608 6.615 6.615 0 01-6.607-6.608zm1.438 0c0 2.85 2.32 5.17 5.17 5.17s5.169-2.32 5.169-5.17-2.32-5.169-5.17-5.169-5.17 2.32-5.17 5.17z"
          className="av"
        />
        <path
          id="path231"
          fill="#c7c7c7"
          stroke="#c7c7c7"
          strokeMiterlimit={10}
          strokeWidth={0.5}
          d="M568.658 468.162c-.547-.025-13.438-.654-19.08-2.67l.455-1.275c5.452 1.947 18.557 2.586 18.688 2.592z"
        />
        <path
          id="path232"
          d="M562.79 559.084H423.825l-.271-.812h-40.092c-.948 0-1.625.677-1.625 1.625s.677 2.98 1.625 2.98h193.176c.136-1.084.767-3.522.903-4.605h-14.345z"
          className="ap"
        />
        <path
          id="path233"
          d="M499.131 544.321l-4.605-11.242-20.045-49.708H391.86l31.694 74.9.406.813h138.83l.406-.812 3.386-6.095h.136-3.928l-35.35.406h-11.514l-1.354.136h-12.055l-1.083-2.574-1.625-4.199z"
          className="av"
        />
        <path
          id="path234"
          d="M439.91 771.439c.493.163 2.355 1.075 2.996 1.123 5.91.442 10.944.424 15.521-.883.78-.223 1.201-3.114 1.44-6.409-3.32 3.526-17.793 2.484-20.354 1.844-2.704-.676-9.165 1.578-13.598 2.555-4.432.976-17.58.075-22.913-.827-3.91-.66-4.87-3.413-5.106-4.84a2.532 2.532 0 00-.497 1.503c-.002.652-1.372 6.491 3.2 7.672 4.037 1.043 22.696 2.632 27.285 1.34 2.012-.568 3.915-1.425 5.953-1.92 1.623-.393 4.133-1.802 6.073-1.158zm-67.007-7.297c.493.163 2.355 1.076 2.997 1.124 5.91.442 10.944.424 15.52-.884.753-.215 1.172-2.922 1.414-6.074-4.125 2.953-17.37 1.978-19.809 1.369-2.704-.677-9.165 1.577-13.597 2.554-4.433.977-17.58.075-22.914-.826-4.267-.722-5.023-3.937-5.155-5.197-.584.487-.963 1.174-.966 2-.002.652-1.372 6.492 3.199 7.672 4.037 1.043 22.697 2.633 27.285 1.34 2.013-.567 3.915-1.425 5.953-1.919 1.624-.394 4.133-1.802 6.073-1.159z"
          className="ap"
        />
        <path id="path235" d="M558.083 370.524l1.938-2.07" className="aa" />
        <path
          id="path236"
          d="M578.777 415.795l-5.797.14 5.376 19.308 2.291 9.818 2.805-4.301 10.847-15.428 11.126-11.267 1.169-3.974-3.039-4.675z"
          className="as"
        />
        <path
          id="path237"
          d="M573.386 406.161c-.021.675.1 1.29.104 2.094l.96 4.954c.348 1.851.765 3.257 1.225 6.443.135.813 2.636 15.358 2.907 16.712.406-3.522-.498-16.713 11.647-23.033 10.732-8.638 13.218-15.443 13.218-15.443s-17.193 5.835-30.06 8.273z"
          className="ao"
        />
        <path
          id="path238"
          d="M574.436 409.867c.39-.433 2.324 11.821 4.045 22.446 1.61 9.933 2.774 10.69 2.774 10.69s6.812-15.247 12.234-21.612c5.421-6.364 10.921-9.428 11.392-12.885 0 0 .236-.102.08-1.673 0 0 7.074 3.175 7.842 12.24 0 0-6.158-.67-13.52 5.489-7.364 6.158-13.77 11.71-18.589 23.49 0 0-4.244-23.245-11.399-30.05-4.544-4.322-8.34-2.094-8.34-2.094s5.323-5.89 13.482-6.04z"
          className="ap"
        />
        <path
          id="path239"
          d="M559.947 353.749c2.247-11.233 13.975-16.336 25.43-13.704 12.657 2.908 21.63 9.704 24.262 22.405 1.616-.777 2.189 1.52 3.715 2.62 4.722 3.406 3.063 10.371.686 14.56-.906 1.599-3.695 2.15-5.567 2.979.105.509-.113 4.132-.252 4.765-2.26 10.279-11.424 23.63-25.05 24.829-14.424 1.27-15.191-11.229-19.745-22.72-4.424-11.164-5.665-24.808-3.48-35.734z"
          className="as"
        />
        <path
          id="path240"
          fill="#b88564"
          strokeWidth={0}
          d="M574.814 394.21c2.028-.905 4.128.286 6.476-.174 2.414-.41 5.873-1.659 7.51-1.707.681-.005.706.905.11 1.287-1.589 1.059-4.247 3.44-6.75 3.724-2.379.303-5.345-1.18-7.244-1.901-.46-.167-.557-1.02-.102-1.23z"
          opacity={0.75}
        />
        <path
          id="path241"
          d="M580.805 398.548a5.933 5.933 0 002.968-.4c.856-.345 1.403.973.55 1.325a7.275 7.275 0 01-3.725.493c-.915-.116-.71-1.525.207-1.419zm-5.227-30.915c.483 2.818.278 5.542-.063 8.591-.16 1.525-.47 3.066-.87 4.566-.39 1.476-.966 2.96-1.185 4.156-.096.617-.072.807.15 1.07.244.265.695.474 1.176.599.445.152 1.046.25 1.455.299.437.002.852-.117 1.31-.433.567-.377 1.158-.67 1.764-.807.59-.164 1.253-.073 1.698-.075.49-.009 1.002-.18 1.393-.618.397-.417.566-.31.696-.315-.092.004.037-.035-.42.668-.431.714-1.08 1.065-1.675 1.233-.65.132-1.083.133-1.592.372a5.53 5.53 0 00-1.415.875c-.539.48-1.247.815-1.904.838-.671-.016-1.147-.06-1.744-.19-.562-.121-1.156-.312-1.733-.88a1.68 1.68 0 01-.386-.557c-.126-.219-.195-.478-.239-.759-.095-.548-.037-1.071.035-1.52.372-1.747.924-3.029 1.331-4.431.441-1.367.754-2.768 1.036-4.201.526-2.867 1.057-5.505 1.182-8.481"
          className="ao"
        />
        <path
          id="path242"
          fill="#edbea1"
          stroke="#b88564"
          strokeLinecap="round"
          strokeMiterlimit={10}
          strokeWidth={1.2216}
          d="M590.192 391.018s1.832-.173 1.508 1.887"
        />
        <path
          id="path243"
          d="M579.426 357.864c3.745-.324 7.473-.627 11.255-.725.982.012 1.82-.07 2.998.155.385.093.516.187.748.277l.641.275 1.281.547 1.074.638c.38.163.554.62.387 1.02a.767.767 0 01-.943.449l-.046-.017-1.253-.271-1.204-.363-.798-.205c-.19-.06-.344-.13-.533-.149.123.013-.636-.11-1.036-.08l-1.34.1c-3.645.364-7.372.934-11.041 1.524-.843.136-1.614-.461-1.722-1.332-.107-.87.49-1.686 1.331-1.82.036-.007.069-.01.103-.014zm-14.086 13.974c-.136-1.168 1.18-1.103 2.336-1.278.644-.097 1.255.354 1.279 1.005a1.814 1.814 0 01-3.615.273m-6.428-8.417l5.278-2.12.216-.084a1.649 1.649 0 11.99 3.136l-6.496 1.597-.013-1.12z"
          className="ap"
        />
        <path
          id="path244"
          d="M613.21 337.715c-1.724-5.195-6.73-7.935-12.301-10.132-7.116-2.807-14.43-2.654-21.818-.822-.133-.071-.906-.19-1.131-.215-2.3-1.482-6.153-1.904-7.921-1.604-.885.15-1.855.416-2.55 1.027-.645.568-.577 1.4-1.054 1.921-.952 1.044-3.88-.31-5.16-.519-1.087-.177-2.244-.239-3.32.065-1.899.535-3.125 1.924-3.452 3.845-.234 1.371.346 3.29-.579 4.247-.375.388-1.355.395-1.843.91-1.603 1.695-.615 4.377.089 6.225 1.072 2.818 2.69 5.3 4.73 7.495.984 2.357 1.443 4.032 2.36 6.49.759 2.028 1.133.358.748-1.54-.261-1.288.208-.434.158-1.557 0-.155-.056-.958.2-1.005.551-.102.107-1.363.524-1.666.17 1.37 2.423 1.928 3.332.561 1.146-1.723 2.018-3.635 2.94-5.511l-.471 1.383c-.616 1.807 1.647 2.654 2.945 1.676 1.438-1.085 1.923-2.588 2.566-4.169.154-.377.513-1.268.981-2.296l-.564 2.192c-.466 1.812 2.282 3.173 3.23 1.326a57.984 57.984 0 012.868-4.951c-.227 1.544-.491 3.15.543 4.519.692.916 2.438 1.313 3.078 0l1.767-3.63c.009.005.019.008.028.012.023.167.05.334.092.499.36 1.379 1.19 2.424 2.498 3.061.9.438 1.86.19 2.448-.622.314-.435.596-.883.864-1.336a62.15 62.15 0 00.698 3.825c.258 1.181 1.84 1.66 2.798.926.755 3.75 1.513 7.5 2.27 11.25.277 1.368 2.35 1.704 3.148.566.017.089.03.179.048.268.28 1.437 1.956 1.546 2.888.766 1.088.481 2.598.037 2.53-1.442l-.118-2.62c.055-.109.1-.222.129-.34.092.218.178.438.273.657.334.768 1.182.968 1.94.774-.307 1.38.672 2.976.55 4.28-.25 2.663-.232 4.142.154 6.783.109.742 1.824-2.05 2.294-1.796.005.135-.992 11.52-.987 11.655.046 1.24-1.433 2.892-.5 2.76-.03.892.102 4.575.07 5.468-.067 1.93 5.256-1.517 5.8-3.417 2.611-9.116 5.268-18.484 5.096-27.978-.092-5.058-1.004-14.593-5.905-18.264z"
          className="ap"
        />
        <path
          id="path245"
          fill="none"
          stroke="#4d4d4d"
          strokeLinecap="round"
          strokeMiterlimit={10}
          strokeWidth={1.5}
          d="M594.252 330.637c.702.112 12.208.672 15.023 9.854"
        />
        <path
          id="path246"
          d="M582.573 368.73c.15.365.549.712.913.562.729-.3 1.35-.343 2.088-.52.077 1.12 1.14 2.046 2.26 1.968 1.12-.078 2.053-1.016 1.967-2.259l-.009-.124a38.746 38.746 0 015.522.368l.248-.017c.373-.026.72-.425.695-.798-.025-.373-.167-.613-.549-.711-2.405-.459-4.909-.536-7.395-.364l-.995.069c-1.358.218-2.717.437-4.068.78-.497.035-.711.55-.677 1.046z"
          className="ap"
        />
        <path
          id="path247"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeMiterlimit={10}
          strokeWidth={1.1}
          d="M570.775 370.546s-3.31-.9-7.86 1.396"
        />
        <path
          id="path248"
          d="M608.851 361.917l-12.996 2.328s-.038 8.287-1.65 9.564c0 0-7.525 2.754-12.967 2.418 0 0-2.755-4.501-2.755-9.607 0 0 2.822-2.822 16.864-2.553m-17.424 4.288s-3.225-.403-5.577.94m-14.3 1.372s3.081 7.693 4.685 8.43c0 0 6.303.464 10.003-1.364 0 0 .276-4.952-1.606-9.699 0 0-3.023-1.837-12.79 2.325"
          className="aa"
        />
        <path
          id="path249"
          fill="#d8a381"
          stroke="#b88564"
          strokeLinecap="round"
          strokeMiterlimit={10}
          strokeWidth={1.5}
          d="M607.43 382.735c.139-.632.134-1.2.029-1.71 1.872-.829 5.183-4.51 6.09-6.108 2.376-4.19 4.035-11.155-.687-14.56-1.525-1.101-3.328-.98-4.945-.204 0 0-1.15 1.043-1.65 4.886"
        />
        <path
          id="path250"
          d="M657.898 507.19l-70.593 29.137a20.422 20.422 0 00-12.63 18.878v43.577c0 14.116 13.978 23.975 27.275 19.239l60.993-21.727a4.85 4.85 0 003.221-4.663l-1.567-80.054c-.067-3.412-3.544-5.69-6.699-4.388z"
          className="ap"
        />
      </g>
      <path
        id="path251"
        d="M499.131 544.321l-4.605-11.242-20.045-49.708h-96.82l28.627 67.653 3.473 8.06H562.79l.406-.812 3.386-6.095h.136-3.928l-35.35.406h-11.514l-1.354.136h-12.055l-1.083-2.574-1.625-4.199z"
        className="ap"
      />
      <path id="path252" d="M468.688 476.993L405.34 335.094" className="ai" />
      <path id="path253" d="M442.872 476.993L348.803 360.47" className="ai" />
      <path id="path254" d="M417.055 476.993l-2.426-1.764" className="aa" />
      <path
        id="path255"
        fill="none"
        stroke="#000"
        strokeDasharray="0 0 5.96 5.96"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M409.808 471.725L257.94 361.35"
      />
      <path id="path256" d="M255.53 359.597l-2.426-1.764" className="aa" />
      <path id="path257" d="M391.24 476.993L164.77 371.472" className="ai" />
      <path
        id="path258"
        d="M139.777 382.247a1.5 1.5 0 01-.236-.019c-19.095-.428-34.593-16.254-34.593-35.377 0-18.747 14.876-34.31 33.443-35.333.882-15.098 7.199-29.285 17.877-40.081 10.784-10.905 25.073-17.4 40.322-18.352 14.928-31.381 46.88-51.61 81.661-51.61 19.849 0 38.685 6.314 54.472 18.256 14.956 11.315 26.21 27.29 31.79 45.09a52.38 52.38 0 012.648-.07c32.394 0 58.748 26.354 58.748 58.748 0 32.193-26.154 58.513-58.33 58.74-.05.005-.1.008-.152.008z"
        className="au"
      />
      <path
        id="path259"
        d="M278.25 202.976c40.236 0 74.22 26.736 85.174 63.409a57.93 57.93 0 013.737-.135c31.617 0 57.248 25.631 57.248 57.249 0 31.528-25.488 57.097-56.982 57.24v.007H139.778v-.014c-18.458-.303-33.33-15.351-33.33-33.881 0-18.546 14.896-33.603 33.375-33.883 1.14-31.53 26.308-56.93 57.743-58.435 14.107-30.44 44.927-51.557 80.685-51.557m0-3c-17.87 0-35.194 5.135-50.1 14.85a92.06 92.06 0 00-32.535 36.823c-15.286 1.165-29.578 7.776-40.415 18.733-10.624 10.743-17.033 24.762-18.218 39.733-8.68.78-16.73 4.57-22.913 10.838-6.85 6.945-10.622 16.142-10.622 25.898 0 9.747 3.766 18.938 10.606 25.88 6.759 6.862 15.759 10.759 25.37 10.995.116.013.234.02.354.02h227.649c.073 0 .146-.002.218-.007 15.958-.126 30.94-6.42 42.209-17.734 11.32-11.367 17.555-26.463 17.555-42.506 0-33.221-27.027-60.249-60.248-60.249-.507 0-1.025.008-1.567.025-5.787-17.654-17.071-33.471-31.966-44.74-16.05-12.142-35.2-18.56-55.377-18.56z"
        className="ar"
      />
      <path
        id="path260"
        d="M260.924 295.157c0-9.453 7.663-17.116 17.116-17.116s17.116 7.663 17.116 17.116c0 6.663-3.815 12.422-9.373 15.25v16.944c0 4.259-3.484 7.743-7.743 7.743s-7.743-3.484-7.743-7.743v-16.944c-5.557-2.828-9.373-8.587-9.373-15.25z"
        className="av"
      />
      <path
        id="path261"
        d="M629.052 452.864s-3.758 7.989-4.289 19.542c-.531 11.554 1.584 19.124-4.629 25.336-4.473 4.473-15.783 11.296-19.634 13.687-3.851 2.391-9.862 8.195-15.811 10.917-7.186 3.29-13.634 2.75-18.85 8.206-4.015 4.2-10.153 7.383-10.153 7.383m75.611-111.009s8.132 1.836 12.592 11.28"
        className="ah"
      />
      <circle id="circle261" cx={518.66309} cy={274.36139} r={22.1703} className="ap" />
      <g id="g262" clipPath="url(#y)">
        <circle id="circle262" cx={521.6322} cy={271.39221} r={22.1703} className="av" />
      </g>
      <path
        id="path262"
        d="M534.415 280.856L552 282.253l-6.222-16.072-11.283 1.116-2.347 6.66z"
        className="ar"
      />
      <path
        id="path263"
        d="M548.359 266.18h-9.322a7.777 7.777 0 000 15.554h24.876"
        className="ak"
      />
      <path id="path264" d="M518.663 258.712c5.393 0 10.158 2.742 12.973 6.906" className="ab" />
      <path id="path265" d="M584.651 281.735h37.53" className="ak" />
      <path id="path266" d="M487.206 243.23h11.652" className="ak" />
      <circle id="circle266" cx={478.64999} cy={247.8166} r={11.2009} className="av" />
      <circle id="circle267" cx={478.64999} cy={247.8166} r={11.2009} />
      <g id="g268" clipPath="url(#z)">
        <circle id="circle268" cx={480.27411} cy={246.1925} r={11.2009} className="av" />
      </g>
      <path id="path268" d="M478.65 240.616c3.97 0 7.2 3.23 7.2 7.2" className="ab" />
      <path
        id="path269"
        d="M274.139 617.453l-5.323-5.317-.203-1.135 6.667.265-.463 6.32z"
        className="ar"
      />
      <path
        id="path270"
        d="M240.318 583.62l-5.272-5.226-.203-1.043.434-1.015 7.943 1.45 1.45 5.623z"
        className="ar"
      />
      <path
        id="path271"
        d="M293.294 531.039l-5.464-5.415-2.09-.174v8.369l7.554 1.25z"
        className="ar"
      />
      <path id="path272" d="M326.995 564.735l-5.294-5.268-.71-.3v6.25l6.332.109z" className="ar" />
      <path
        id="path273"
        d="M316.597 564.174h-5.115a37.815 37.815 0 00-3.643-8.793l3.617-3.618a1.936 1.936 0 000-2.738l-11.527-11.527c-.726-.726-2.011-.726-2.737 0l-3.618 3.617a37.846 37.846 0 00-8.793-3.641v-5.116c0-1.07-.866-1.937-1.936-1.937h-16.302c-1.07 0-1.936.867-1.936 1.937v5.116a37.846 37.846 0 00-8.793 3.641l-3.617-3.617a1.936 1.936 0 00-2.738 0l-11.528 11.527a1.936 1.936 0 000 2.738l3.618 3.618a37.78 37.78 0 00-3.643 8.793h-5.116c-1.07 0-1.936.867-1.936 1.936v16.302c0 1.07.867 1.936 1.936 1.936h5.116a37.79 37.79 0 003.643 8.793l-3.618 3.618a1.936 1.936 0 000 2.738l11.528 11.527a1.936 1.936 0 002.737 0l3.618-3.617a37.85 37.85 0 008.793 3.642v5.115c0 1.07.866 1.936 1.936 1.936h16.302c1.07 0 1.936-.866 1.936-1.936v-5.115a37.845 37.845 0 008.793-3.642l3.617 3.617a1.936 1.936 0 002.738 0l11.527-11.527a1.936 1.936 0 000-2.738l-3.617-3.618a37.809 37.809 0 003.643-8.792h5.115c1.07 0 1.936-.867 1.936-1.937V566.11c0-1.07-.867-1.936-1.936-1.936zm-26.078 10.087c0 8.726-7.1 15.825-15.825 15.825s-15.825-7.1-15.825-15.825 7.098-15.825 15.825-15.825 15.825 7.098 15.825 15.825z"
        className="ar"
      />
      <path
        id="path274"
        d="M320.47 577.249v-16.302h-6.625a35.987 35.987 0 00-4.57-11.031l4.685-4.685-11.527-11.527-4.685 4.684a35.987 35.987 0 00-11.03-4.57v-6.624h-16.303v6.625a35.987 35.987 0 00-11.03 4.57l-4.685-4.685-11.527 11.527 4.684 4.685a35.987 35.987 0 00-4.57 11.03h-6.624v16.303h6.624a35.989 35.989 0 004.57 11.03l-4.684 4.685 11.527 11.527 4.684-4.684a35.988 35.988 0 0011.031 4.57V611h16.302v-6.625a35.987 35.987 0 0011.031-4.57l4.685 4.685 11.527-11.527-4.685-4.684a35.99 35.99 0 004.57-11.031h6.624zm-41.904 9.61c-9.81 0-17.761-7.952-17.761-17.761s7.952-17.762 17.761-17.762 17.762 7.952 17.762 17.762-7.952 17.761-17.762 17.761z"
        className="av"
      />
      <circle id="circle274" cx={336.66241} cy={545.60828} r={11.4303} className="ad" />
      <path id="path275" d="M332.293 535.046l-1.643-3.97" className="ad" />
      <path id="path276" d="M342.655 560.092l-1.643-3.97" className="ad" />
      <path id="path277" d="M326.115 549.944l-3.97 1.643" className="ad" />
      <path id="path278" d="M351.16 539.582l-3.97 1.642" className="ad" />
      <path id="path279" d="M326.118 541.216l-3.969-1.646" className="ad" />
      <path id="path280" d="M351.156 551.599l-3.97-1.646" className="ad" />
      <path id="path281" d="M332.284 556.119l-1.646 3.968" className="ad" />
      <path id="path282" d="M342.667 531.081l-1.646 3.969" className="ad" />
      <circle id="circle282" cx={248.38651} cy={500.31421} r={21.909599} className="ad" />
      <path id="path283" d="M255.548 479.608l2.691-7.783" className="ad" />
      <path id="path284" d="M238.566 528.71l2.692-7.784" className="ad" />
      <path id="path285" d="M227.744 493.122l-7.783-2.691" className="ad" />
      <path id="path286" d="M276.845 510.103l-7.783-2.691" className="ad" />
      <path id="path287" d="M238.847 480.607l-3.6-7.407" className="ad" />
      <path id="path288" d="M261.559 527.334l-3.6-7.407" className="ad" />
      <path id="path289" d="M228.743 509.823l-7.407 3.6" className="ad" />
      <path id="path290" d="M275.47 487.11l-7.407 3.6" className="ad" />
    </g>
  </svg>
);

export default GuidedTourIntroBannerDark;
